<template>
  <component :is="tag" class="facility-iso-logos">
    <div class="section-inner">
      <ul
        :class="`facility-iso-logos-list has-${
          blok.facilityIsoLogos?.length
        }_logo${blok.facilityIsoLogos?.length > 1 ? 's' : ''}`"
      >
        <li
          v-for="facilityIsoLogo in blok.facilityIsoLogos"
          :key="facilityIsoLogo._uid"
          class="facility-iso-logo size-xs"
        >
          <StoryblokComponent
            class="facility-iso-logo--logo"
            :blok="facilityIsoLogo.logo[0]"
          />
          <div
            class="facility-iso-logo--text"
            v-html="useRenderRichText(facilityIsoLogo.text)"
          ></div>
        </li>
      </ul>
    </div>
  </component>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});
</script>

<style lang="scss" scoped>
.facility-iso-logos {
  &-list {
    display: flex;
    flex-direction: column;
    gap: 1.26rem;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    @include for-tablet-landscape-up {
      flex-direction: row;
      justify-content: space-around;
      gap: 1.5rem;
      width: 100%;
      &.has-1_logo,
      &.has-2_logos {
        .facility-iso-logo {
          display: flex;
          align-items: center;
          gap: 1.26rem;
          width: fit-content;
          max-width: none;
          :deep(img) {
            margin: 0 0 0 auto;
            height: 100px;
            width: auto;
            max-width: none;
          }
        }
      }
      &.has-2_logos .facility-iso-logo {
        width: 50%;
      }
      &.has-3_logos .facility-iso-logo {
        width: calc(100% / 3);
      }
      &.has-4_logos .facility-iso-logo {
        width: 25%;
      }
      &:not(.has-1_logo, .has-2_logos) .facility-iso-logo :deep(img) {
        height: 5.625rem;
        width: auto;
      }
    }
    @include for-desktop-up {
      width: 78%;
    }
  }
}
.facility-iso-logo {
  max-width: 38rem;
  line-height: 150%;
  :deep(img) {
    display: block;
    margin: 0 auto 1rem;
  }
}
</style>
